/**
 * Sprint 18 (S18.1) · Reusable Hint-Pill
 *
 * Mockup-konforme Pills für UX-Hinweise im Capture-Flow.
 * Variants: info (grau), success (grün), warning (orange), magic (sparkles, grün-tint).
 *
 * Verwendet Lucide-Icons; Default-Icon je Variant, kann via `icon`-Prop überschrieben werden.
 */
import { ComponentType, ReactNode } from 'react';
import { Info, CheckCircle2, AlertTriangle, Sparkles, type LucideProps } from 'lucide-react';

export type HintVariant = 'info' | 'success' | 'warning' | 'magic';

interface HintProps {
  variant?: HintVariant;
  icon?: ComponentType<LucideProps>;
  children: ReactNode;
  className?: string;
}

const DEFAULT_ICON: Record<HintVariant, ComponentType<LucideProps>> = {
  info: Info,
  success: CheckCircle2,
  warning: AlertTriangle,
  magic: Sparkles,
};

export function Hint({ variant = 'info', icon, children, className }: HintProps) {
  const IconCmp = icon ?? DEFAULT_ICON[variant];
  const cls = ['hint', `hint--${variant}`, className].filter(Boolean).join(' ');
  return (
    <div className={cls} role="note">
      <IconCmp size={14} className="hint__icon" aria-hidden="true" />
      <span className="hint__text">{children}</span>
    </div>
  );
}
